<template>
    <div>
        <app-sub-title text="Usuarios pendientes de activación"/>
        <app-users-pending-activation-filters
            @filter="onFilter"
        />    
        <app-users-pending-activation-list
            :data="data"
            @change-page="changePage"
            @sort="onSort"
        />
    </div>
</template>

<script>
import UsersPendingActivationList from './UsersPendingActivationList/UsersPendingActivationList.vue';
import UsersPendingActivationFilters from './UsersPendingActivationFilters/UsersPendingActivationFilters.vue';
import peopleRepository from '../../../repositories/people.repository.js';
export default {
    components: {
        appUsersPendingActivationList: UsersPendingActivationList,
        appUsersPendingActivationFilters: UsersPendingActivationFilters
    },
    data(){
        return{
            data: {},
            filters: {},
            sort: {
                sortBy: 'name',
                sortDir: 'asc'
            },
            page: 1
        }
    },
    methods: {
        loadUsersPendingActivation(){
            const pr = {...peopleRepository};
            const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
            pr.getPeoplePendingActivation(filters, this.page)
            .then(({ data }) => {
                this.data = data;
            })
            .catch(error => {
                toastr.error('Error al cargar los usuarios pendientes de aprobación');
            });
        },
        changePage(page){
            this.page = page;
            this.loadUsersPendingActivation();
        },
        onFilter(filters){
            this.filters = filters;
            this.loadUsersPendingActivation();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadUsersPendingActivation();
        },
        initialize(){
            this.load('clients');
            this.loadUsersPendingActivation();
        }
    },
    created(){
        this.initialize();
    }
}
</script>